<div class="pme-container">
  <div class="pme-row display-utils-row display-utils-center">
    <div class="pme-col display-utils-gt-sm-flex-50">
      <main>
        <pme-hero type="info" title="Rotas do E-commerce">
          <p>Preencha os business e user ids para gerar todas as rotas de cenários possíveis</p>
        </pme-hero>

        <form [formGroup]="this.identificationForm" (ngSubmit)="onSubmit()">
          <div>
            <div class="display-utils-row-wrap display-utils-gt-xs-gap-24">
              <div class="display-utils-flex-100 display-utils-gt-xs-flex-half-gap-24">
                <mat-form-field appearance="outline">
                  <mat-label>Identificador da empresa</mat-label>
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="this.businessId"
                    formControlName="businessId"
                    id="businessId"
                    name="businessId"
                    required
                  />
                  <mat-error>{{ getIdentificationErrors().businessId }}</mat-error>
                </mat-form-field>
             </div>

             <div class="display-utils-flex-100 display-utils-gt-xs-flex-half-gap-24">
                <mat-form-field appearance="outline">
                  <mat-label>Identificador do cliente</mat-label>
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="this.userId"
                    formControlName="userId"
                    id="userId"
                    name="businessId"
                    required
                  />
                  <mat-error>{{ getIdentificationErrors().userId }}</mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="pme-fixed-button display-utils-row display-utils-between-center display-utils-gap-29">
              <button mat-flat-button color="primary" type="submit" class="pme-btn-lg"
                [disabled]="submitting || !this.identificationForm.valid">
                <div class="display-utils-row display-utils-center-center display-utils-gap-8">
                  <mat-spinner *ngIf="submitting" diameter="20" aria-label="Carregando"></mat-spinner>
                  <div>Gerar rotas</div>
                </div>
              </button>
            </div>

            <div class="searchForm" *ngIf="submitted">
              <form [formGroup]="searchForm">
                <input type="text" formControlName="searchValue" (keyup)="searchRoutes()" placeholder="Buscar...">
              </form>
            </div>

            <div id="classifications" class="classifications" *ngIf="this.searchForm.value.searchValue === ''">
              <mat-accordion>
                <ng-container *ngFor="let key of getClassificationKeys()">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      {{ this.classifications[key][0].classification.name }}
                    </mat-expansion-panel-header>
                   <mat-nav-list class="display-utils-col display-utils-between-flexstart" flex>
                      <ng-container *ngFor="let item of classifications[key]">
                      <a mat-list-item (click)="open(item.url)"> {{ item.type }} </a>
                      </ng-container>
                    </mat-nav-list>
                  </mat-expansion-panel>
                </ng-container>
              </mat-accordion>
            </div>

            <div *ngIf="this.searchForm.value.searchValue !== ''">
              <mat-nav-list>
                <a mat-list-item *ngFor="let item of this.foundRoutes" [href]="item.url" (click)="open(item.url)"> {{ item.type }} </a>
              </mat-nav-list>
            </div>

            <div class="hash" *ngIf="this.searchForm.value.searchValue === ''">
              <mat-form-field appearance="outline" *ngIf="this.selfAttendanceHash">
                <mat-label>Hash de auto-atendimento</mat-label>
                <input
                  matInput
                  type="text"
                  #hash
                  [ngxClipboard]="hash"
                  [value]="this.selfAttendanceHash"
                  (cbOnSuccess)="copied('hash de auto-atendimento copiado!')"
                />
              </mat-form-field>
            </div>

            <pme-alert type="error" title="Erro" *ngIf="this.routesErrors && this.routesErrors.length">
              <div *ngFor="let error of this.routesErrors">{{error}}</div>
            </pme-alert>

          </div>
        </form>
      </main>
    </div>
  </div>

</div>
